import { getHistCommodities } from "@/_core/data/api_calls/relatives_values/historical/getHistCommodities";
import { getHistCurrencies } from "@/_core/data/api_calls/relatives_values/historical/getHistCurrencies";

/**
 * Retrieves historical data for relative values based on the selected asset type.
 * @param {object} ctx - Context variables.
 * @param {string} asset - Asset type ("currency" or "commodity").
 * @param {object} assetExtraParams - Additional parameters for the query (default: {}).
 * @returns {Promise} - A promise resolving to historical data for the specified asset.
 */
export function getHistData(ctx, asset, assetExtraParams = {}) {
  // Determine which function to call based on the asset type.
  if (asset === "currency") {
    return getHistCurrencies(ctx); // Fetch historical data for currencies.
  } else if (asset === "commodity") {
    return getHistCommodities(ctx, assetExtraParams); // Fetch historical data for commodities.
  }
}
